import React, { useState, useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';


const RegistrationForm: React.FC = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  

  const [registrationSuccess, setRegistrationSuccess] = useState(false);

   const [searchParams, setSearchParams] = useSearchParams();


    useEffect(() => {
    const isValid =
      firstName.trim() !== '' &&
      lastName.trim() !== '' &&
      email.trim() !== '' &&
      password.trim() !== '';
    setIsFormValid(isValid);
    // console.log('firstName:', firstName, 'lastName:', lastName, 'email:', email, 'password:', password, 'isFormValid:', isValid);
  }, [firstName, lastName, email, password]);

  

  useEffect(()=>{
    if(registrationSuccess) {

       getPaymentToken();
       

    }
  },[registrationSuccess])


  const getPaymentToken = async () => {

    

    try {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    const tomorrowISO = today.toISOString().slice(0, 10);
      const response = await fetch('https://ksa.paymob.com/v1/intention/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token sau_sk_test_48d19f720dee2ae185d9da683745aa99e6f44a932d4c7a4d16aa5a9f0f82f0be`
        },
        body: JSON.stringify({
  "amount": 10000,
  "payment_methods": [15492],
  "currency": "SAR",
  "redirection_url": "https://subscribe.abmfy.com/paymentcallback",
   "items": [
    {
      "name": "Individual",
      "amount": 10000,
      "description": "Item description",
      "quantity": 1
    }
  ],
  "billing_data": {
    "first_name": "ala",
    "last_name": "zain",
    "phone_number": "+966512345678",
    "email": "ali@gmail.com"
  },
  "subscription_plan_id": 1371,
  "subscription_start_date":tomorrowISO
})
      });

      if (response.ok) {
        const data = await response.json();
        window.location.href = 'https://ksa.paymob.com/unifiedcheckout/?publicKey=sau_pk_test_bzdJuksxUQUVu6pETnQz3v0uxWzp3GYb&clientSecret='+data.client_secret;
        console.log(data)
      } else {
        const errorData = await response.json(); // Parse the JSON error response
        setErrorMessage('Subscription failed:'+errorData.message);
        setRegistrationSuccess(false);
      }
    } catch (error) {
      console.error('Error during registration:', error);
      setRegistrationSuccess(false);
    }

  }

  const getPackageAmount = () => {
    const getSets : any = searchParams.get("sets");
    const getPackageid : any = searchParams.get("packageId");
    const sets = parseInt(getSets);
    const packageid = parseInt(getPackageid);

    if(packageid === 1) {
      return 10000;
    }
    if(packageid === 2) {
      return sets * 8500;
    }
    if(packageid === 3) {
      return sets * 6500;
    }
  }


  const handleGetPaymentLink = async (token: string) => {

     try {
      const response = await fetch('https://ksa.paymob.com/api/ecommerce/payment-links', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
         payment_methods: [15492],
         amount_cents: getPackageAmount(),
         email: email,
         phoneNumber: 966506227067,
         is_live: false,
         redirection_URL:'https://subscribe.abmfy.com/paymentcallback'
        }),
      });

      if (response.ok) {
        const data = await response.json();
        window.location.href = data.client_url;
      } else {
        const errorData = await response.json(); // Parse the JSON error response
        setErrorMessage('Subscription failed:'+errorData.message);
        setRegistrationSuccess(false);
      }
    } catch (error) {
      console.error('Error during registration:', error);
      setRegistrationSuccess(false);
    }

  }


   const validatePackage = () => {
    const getSets : any = searchParams.get("sets");
    const getPackageid : any = searchParams.get("packageId");
    const sets = parseInt(getSets);
    const packageid = parseInt(getPackageid);
    if(!sets || !packageid || isNaN(sets) || isNaN(packageid)) return true;
    if(packageid === 1 && sets !== 1) return true;
    if(packageid === 2 && (sets < 3 || sets > 9)) return true;
    if(packageid === 3 && (sets < 10 || sets > 25)) return true;
    return false;
   }

   if(validatePackage()) {
    return <div>Error you must follow wrong url.</div>
   }



  
const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setErrorMessage('');
    setRegistrationSuccess(true);
    const getSets : any = searchParams.get("sets");
    const getPackageid : any = searchParams.get("packageId");
    const sets = parseInt(getSets);
    const packageId = parseInt(getPackageid);

    try {
      const response = await fetch('https://abmfy-be.onrender.com/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName,
          lastName,
          company,
          email,
          password,
          packageId,
          sets
        }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        localStorage.setItem('userId', data.user.id);
        setRegistrationSuccess(true);
      } else {
        const errorData = await response.json(); // Parse the JSON error response
        setErrorMessage('Subscription failed:'+errorData.message);
        setRegistrationSuccess(false);
      }
    } catch (error) {
      console.error('Error during registration:', error);
      setRegistrationSuccess(false);
    }
  };
  

 

  return (
    <>
    {registrationSuccess && <div className='loading'>
      <img src="/spinner.svg" alt="" />
    </div>}
    <div className='reg-form'>
      <h2 className='reg-head'>Please complete the form to subscibe to ABMFY</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="company">Company:</label>
          <input
            type="text"
            id="company"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={!isFormValid}>Subscribe</button>
      </form>
      {errorMessage && <p style={{ color: 'red', marginTop: '15px' }}>{errorMessage}</p>}
    </div>
    </>
  );
};

export default RegistrationForm;